const brands = ['alientech', 'autotuner', 'magic-motorsport', 'dimsport'];
export function responsiveProductImage(src) {
  const name = brands.find(brand => src === `/assets/brands/${brand}.webp`);
  return name ? {
    srcSet: `/assets/brands/${name}-400.webp 400w, /assets/brands/${name}-800.webp 800w, ${src} 1200w`,
    sizes: '(max-width: 639px) calc(100vw - 48px), (max-width: 1023px) 45vw, 300px',
  } : {};
}